export default Object.freeze({
  FullName: 'full-name',
  Email: 'email',
  ExtraField: 'extra-field',
  Position: 'position',
  Area: 'area',
});
